import { useFetchMedia } from '@/hooks/useFetchMedia';
import { PolygonData, PolygonOverlay } from './PolygonOverlay';

interface PolygonOverlayWrapperProps {
  mediaEndpointUrl: string;
  polygonData: PolygonData[];
  isVideo?: boolean;
}

export function PolygonOverlayWrapper({
  mediaEndpointUrl,
  polygonData,
  isVideo,
}: PolygonOverlayWrapperProps) {
  const { mediaUrl, loading } = useFetchMedia({
    mediaEndpointUrl,
  });

  return (
    <PolygonOverlay
      mediaUrl={mediaUrl ?? ''}
      loading={loading}
      polygonData={polygonData}
      isVideo={isVideo}
    />
  );
}
